import React from 'react';
import { SearchIcon } from 'lucide-react';
export const BackofficeFilters = () => {
  return <div className="bg-white p-6 rounded-lg shadow mb-6" data-id="element-35">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4" data-id="element-36">
        <div className="relative lg:col-span-2" data-id="element-37">
          <input type="text" placeholder="Buscar usuarios..." className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-38" />
          <SearchIcon className="absolute left-3 top-3.5 h-5 w-5 text-gray-400" data-id="element-39" />
        </div>
        <div data-id="element-40">
          <select className="w-full px-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-41">
            <option value="" data-id="element-42">Zona</option>
            <option data-id="element-43">Zona Norte</option>
            <option data-id="element-44">Zona Sur</option>
            <option data-id="element-45">Zona Este</option>
            <option data-id="element-46">Zona Oeste</option>
          </select>
        </div>
        <div data-id="element-47">
          <select className="w-full px-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-48">
            <option value="" data-id="element-49">Territorio</option>
            <option data-id="element-50">Territorio A</option>
            <option data-id="element-51">Territorio B</option>
            <option data-id="element-52">Territorio C</option>
          </select>
        </div>
        <div data-id="element-53">
          <select className="w-full px-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-54">
            <option value="" data-id="element-55">Rol</option>
            <option data-id="element-56">Administrador</option>
            <option data-id="element-57">Supervisor</option>
            <option data-id="element-58">Gestor</option>
            <option data-id="element-59">Brigada</option>
          </select>
        </div>
      </div>
    </div>;
};